import React from 'react';
import { Box, Skeleton } from '@mui/material';

const MacroImpulseSkeleton = () => {
  return (
    <Box sx={{ width: '100%', px: 0, py: { xs: 1, sm: 2 } }}>
      {/* Header */}
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Skeleton variant="rounded" width={42} height={42} animation="wave" sx={{ borderRadius: 1.5 }} />
          <Box>
            <Skeleton variant="text" width={260} height={24} animation="wave" />
            <Skeleton variant="text" width={200} height={14} animation="wave" sx={{ mt: 0.5 }} />
            <Skeleton variant="text" width={100} height={12} animation="wave" sx={{ mt: 0.25 }} />
          </Box>
        </Box>
        <Skeleton variant="rounded" width={90} height={36} animation="wave" sx={{ borderRadius: '4px' }} />
      </Box>

      {/* Summary Cards */}
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(4, 1fr)' },
        gap: 1.5, mb: 2,
      }}>
        {[1, 2, 3, 4].map((i) => (
          <Box key={i} sx={{
            p: 2, border: '1px solid', borderColor: 'divider',
            borderRadius: 2.5, bgcolor: 'background.paper',
          }}>
            <Skeleton variant="text" width="50%" height={14} animation="wave" sx={{ mb: 1 }} />
            <Skeleton variant="text" width="40%" height={28} animation="wave" sx={{ mb: 1 }} />
            <Skeleton variant="rounded" width="100%" height={5} animation="wave" sx={{ borderRadius: 3 }} />
          </Box>
        ))}
      </Box>

      {/* Table */}
      <Box sx={{
        border: '1px solid', borderColor: 'divider',
        borderRadius: 2.5, bgcolor: 'background.paper', overflow: 'hidden',
      }}>
        <Box sx={{ px: 2.5, py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
          <Skeleton variant="text" width={180} height={20} animation="wave" />
        </Box>

        {/* Column headers */}
        <Box sx={{
          display: 'flex', gap: 2, px: 2, py: 1,
          borderBottom: '2px solid', borderColor: 'divider',
        }}>
          {[30, 120, 70, 60, 90, 180].map((w, i) => (
            <Skeleton key={i} variant="text" width={w} height={14} animation="wave" />
          ))}
        </Box>

        {/* Rows */}
        {Array.from({ length: 11 }).map((_, i) => (
          <Box key={i} sx={{
            display: 'flex', alignItems: 'center', gap: 2,
            px: 2, py: 1.25,
            borderBottom: i < 10 ? '1px solid' : 'none', borderColor: 'divider',
          }}>
            <Skeleton variant="text" width={20} height={18} animation="wave" />
            <Skeleton variant="text" width={110} height={18} animation="wave" sx={{ flex: 1 }} />
            <Skeleton variant="text" width={50} height={18} animation="wave" />
            <Skeleton variant="text" width={40} height={18} animation="wave" />
            <Skeleton variant="text" width={70} height={18} animation="wave" />
            <Box sx={{ display: 'flex', gap: 0.5 }}>
              <Skeleton variant="rounded" width={60} height={22} animation="wave" sx={{ borderRadius: 1 }} />
              <Skeleton variant="rounded" width={60} height={22} animation="wave" sx={{ borderRadius: 1 }} />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default MacroImpulseSkeleton;
